var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { SurveyQuestionAndErrorsWrapped, SurveyQuestionErrorCell } from "./reactquestion";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactSurveyElement } from "./reactquestion_element";
import { TitleContent } from "./components/title/title-content";
var SurveyQuestionMultipleText = /** @class */ (function (_super) {
    __extends(SurveyQuestionMultipleText, _super);
    function SurveyQuestionMultipleText(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionMultipleText.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMultipleText.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        var tableRows = this.question.getRows();
        var rows = [];
        for (var i = 0; i < tableRows.length; i++) {
            if (tableRows[i].isVisible) {
                rows.push(this.renderRow(i, tableRows[i].cells, cssClasses));
            }
        }
        return (React.createElement("table", { className: this.question.getQuestionRootCss() },
            React.createElement("tbody", null, rows)));
    };
    SurveyQuestionMultipleText.prototype.renderCell = function (cell, cssClasses, index) {
        var cellContent;
        var focusIn = function () { cell.item.focusIn(); };
        if (cell.isErrorsCell) {
            cellContent = React.createElement(SurveyQuestionErrorCell, { question: cell.item.editor, creator: this.creator });
        }
        else {
            cellContent = React.createElement(SurveyMultipleTextItem, { question: this.question, item: cell.item, creator: this.creator, cssClasses: cssClasses });
        }
        return (React.createElement("td", { key: cell.item.id, className: cell.className, onFocus: focusIn }, cellContent));
    };
    SurveyQuestionMultipleText.prototype.renderRow = function (rowIndex, cells, cssClasses) {
        var key = "item" + rowIndex;
        var tds = [];
        for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            tds.push(this.renderCell(cell, cssClasses, i));
        }
        return (React.createElement("tr", { key: key, className: cssClasses.row }, tds));
    };
    return SurveyQuestionMultipleText;
}(SurveyQuestionElementBase));
export { SurveyQuestionMultipleText };
var SurveyMultipleTextItem = /** @class */ (function (_super) {
    __extends(SurveyMultipleTextItem, _super);
    function SurveyMultipleTextItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyMultipleTextItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyMultipleTextItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyMultipleTextItem.prototype.getStateElements = function () {
        return [this.item, this.item.editor];
    };
    Object.defineProperty(SurveyMultipleTextItem.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyMultipleTextItem.prototype.renderElement = function () {
        var item = this.item;
        var cssClasses = this.cssClasses;
        var titleStyle = {};
        if (!!this.question.itemTitleWidth) {
            titleStyle.minWidth = this.question.itemTitleWidth;
            titleStyle.width = this.question.itemTitleWidth;
        }
        return (React.createElement("label", { className: this.question.getItemLabelCss(item) },
            React.createElement("span", { className: cssClasses.itemTitle, style: titleStyle },
                React.createElement(TitleContent, { element: item.editor, cssClasses: item.editor.cssClasses })),
            React.createElement(SurveyMultipleTextItemEditor, { cssClasses: cssClasses, itemCss: this.question.getItemCss(), question: item.editor, creator: this.creator })));
    };
    return SurveyMultipleTextItem;
}(ReactSurveyElement));
export { SurveyMultipleTextItem };
var SurveyMultipleTextItemEditor = /** @class */ (function (_super) {
    __extends(SurveyMultipleTextItemEditor, _super);
    function SurveyMultipleTextItemEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyMultipleTextItemEditor.prototype.renderElement = function () {
        return React.createElement("div", { className: this.itemCss }, this.renderContent());
    };
    return SurveyMultipleTextItemEditor;
}(SurveyQuestionAndErrorsWrapped));
export { SurveyMultipleTextItemEditor };
ReactQuestionFactory.Instance.registerQuestion("multipletext", function (props) {
    return React.createElement(SurveyQuestionMultipleText, props);
});
